import { sortBy } from 'lodash';
import React from 'react';

import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPoint,
  GraphInstanceProps
} from '../index';

import { FormatDate } from '../../../../libs/time';
import { IEpxAsthma } from '../../../../libs/apps/epxasthma';

const EpxAsthmaGraphs: React.FC<GraphInstanceProps> = (props): JSX.Element => {
  const graph: GraphBlueprint<IEpxAsthma> = {
    name: 'Blood Sugar Graph',
    config: {
      title: {
        text: 'EpxAsthma - Breathing'
      },
      chart: {
        type: 'line'
      },
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: {
          text: null
        }
      },
      yAxis: [
        {
          title: {
            text: 'Breathing'
          },
          max: 3,
          min: -1,
          tickInterval: 1,
          tickAmount: 5,
          labels: {
            formatter: function () {
              if (this.value === 0) {
                return 'Worse';
              } else if (this.value === 1) {
                return 'Same';
              } else if (this.value === 2) {
                return 'Better';
              }
              return null;
            }
          }
        },
        {
          title: {
            text: 'Peak Flow'
          },
          opposite: true,
          gridLineWidth: 0
        }
      ],
      responsive: {}
    },
    draw: (sessions, currentOptions) => {
      const options: GraphOptions = {
        series: []
      };
      const breathingSeries: GraphSeries = {
        type: 'line',
        name: 'Breathing',
        tooltip: {
          pointFormatter: function (this) {
            let point = `<span style=\"color:${this.color};\">\u25CF</span> ${this.series.name}: <b>`;
            if (this.y === 0) {
              point += 'Worse';
            } else if (this.y === 1) {
              point += 'Same';
            } else if (this.y === 2) {
              point += 'Better';
            }
            point += '</b></span><br/>';
            return point;
          }
        }
      };
      const breathingData: GraphPoint[] = [];
      const peakFlowSeries: GraphSeries = {
        type: 'column',
        name: 'Peak Flow',
        yAxis: 1
      };
      const peakFlowData: GraphPoint[] = [];
      sessions = sortBy(sessions, (session) => session.time);
      for (const [i, session] of sessions.entries()) {
        breathingData.push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: session.breathing,
          x: i
        });
        peakFlowData.push({
          id: String(session.id),
          name: FormatDate(session.time, 'MM/DD'),
          y: session.peakFlow,
          x: i
        });
      }
      breathingSeries.data = breathingData;
      peakFlowSeries.data = peakFlowData;
      options.series = [breathingSeries, peakFlowSeries];
      options.xAxis = {
        ...currentOptions.xAxis
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxAsthma>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxAsthmaGraphs;
